
<div
    class="Infobox"
    :class="[{ 'is-active': isActive }, 'is-' + type, { 'is-inline': inline }, `size-${size}`]"
>
    <div class="description-card">
        <i :class="iconClass"></i>
        <div class="description-content">
            <h4 v-if="title">{{ title }}</h4>
            <p v-if="message" :style="{ marginTop: title ? '8px' : '4px' }">{{ message }}</p>
            <slot></slot>
        </div>
    </div>
    <span v-if="hasCloseButton && !inline" class="Icon-close" @click="closeModal"></span>
</div>
